import { ActivityId } from '@shared/models/activity-class.model';
import { ActivityEnum } from '@shared/models/activities.model';
import { isOneOf } from '../array.helpers';
import { ActivityType } from '@shared/models/design/activities/activity-type.model';

/**
 * Get heating effect from a resident in kW
 * See page 4: https://www.boverket.se/Resources/constitutiontextstore/BEN/xml/Konsoliderad_BEN_BFS_2016_12.pdf
 * @param activityId The activity of the building
 * @returns heating effect from a resident in W
 */
export const getHeatingEffectInWPerOccupant = (
  activityId: ActivityId | ActivityType | ActivityEnum,
) => {
  if (isOneOf([ActivityId.Office, ActivityType.Office], activityId)) {
    return 108;
  }
  return 80;
};
